import React from 'react'
import styled from 'styled-components'
import uniqBy from 'lodash.uniqby'

import List from '../../atoms/List'
import ListItem from '../../atoms/ListItem'
import Icon from '../../atoms/Icon'

// FIXME: excluding font awesome (starting with fab, fal, etc.) and gatedCommunity
const excludedIcons = /fa[bsrpdl] |gatedCommunity/

const StyledList = styled(List)`
  flex-direction: ${props => (props.isGrid ? 'row' : 'column')};
  align-self: ${props => (props.isGrid ? undefined : 'flex-end')};
  width: ${props => (props.isGrid ? undefined : '30%')};

  @media (min-width: 992px) and (max-width: 1200px) {
    display: ${props => (props.isGrid ? undefined : 'none')};
  }
`

const StyledListItem = styled(ListItem)`
  display: flex;
  align-items: ${props => (props.isGrid ? undefined : 'center')};

  &:not(:last-child) {
    margin-bottom: ${props => (props.isGrid ? undefined : '21px')};
    margin-right: ${props => (props.isGrid ? '14px' : undefined)};
  }

  svg {
    color: #5d5e5e;
  }
`

const IconName = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.12px;
  color: ${props => props.theme.colors.black400};
`

const Star = styled(Icon).attrs({
  icon: 'StarIcon',
})`
  height: 16px;
  width: 16px;
`

export default ({ isGrid, amenities, max = 4 }) => {
  return (
    <StyledList isGrid={isGrid}>
      {uniqBy(amenities, 'icon')
        .filter(amenity => amenity.icon && !amenity.icon.match(excludedIcons))
        .slice(0, max)
        .map((amenity, i) => (
          <StyledListItem key={i} isGrid={isGrid}>
            {amenity.icon ? (
              <Icon title={amenity.name} icon={amenity.icon} size='1x' fixedWidth />
            ) : (
              <Star />
            )}
            {!isGrid ? <IconName>{amenity.name}</IconName> : null}
          </StyledListItem>
        ))}
    </StyledList>
  )
}
